
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { BadgePercent, Car, CreditCard } from "lucide-react";

interface FirstTimePromoPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const FirstTimePromoPopup = ({ open, onOpenChange }: FirstTimePromoPopupProps) => {
  const navigate = useNavigate();

  const handleListSpot = () => {
    onOpenChange(false);
    navigate("/list-spot");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="bg-blue-500 p-3 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <BadgePercent className="h-8 w-8 text-white" />
          </div>
          <DialogTitle className="text-xl font-bold text-center">List Your Spot & Earn!</DialogTitle>
          <DialogDescription className="text-center">
            Congratulations on your first booking! List your parking space on Easy Parking and 
            get an additional 10% off on your next booking.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="flex items-center space-x-3 bg-blue-50 p-3 rounded-lg">
            <Car className="h-5 w-5 text-blue-600 flex-shrink-0" />
            <div className="text-sm">
              <p className="font-medium">Share your unused parking space</p>
              <p className="text-gray-500">Turn your empty parking space into income</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 bg-green-50 p-3 rounded-lg">
            <CreditCard className="h-5 w-5 text-green-600 flex-shrink-0" />
            <div className="text-sm">
              <p className="font-medium">Earn money with zero investment</p>
              <p className="text-gray-500">Get paid directly to your account</p>
            </div>
          </div>
        </div>

        <DialogFooter className="sm:justify-center gap-2 flex-col sm:flex-row">
          <Button 
            onClick={handleListSpot} 
            className="bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800"
          >
            List My Parking Spot
          </Button>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
          >
            Maybe Later
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FirstTimePromoPopup;
